const _categories =  {
  tops: {id: 1, name: 'トップス' },
  outer: {id: 2, name: 'アウター' },
  onepiece: {id: 3, name: 'ワンピース' },
  bottoms: {id: 4, name: 'ボトムス' },
  shoes: {id: 5, name: 'シューズ' },
  bag: {id: 6, name: 'バッグ・ポーチ' },
  accessories: {id: 7, name: 'アクセサリー' },
  goods: {id: 8, name: '雑貨・小物' },
  innerclothes: {id: 9, name: 'インナーウェア' },
  swimwear: {id: 90, name: '水着' },
};
const _genders = {
  unisex: {id: 0, name: 'ユニセックス' },
  ladies: {id: 1, name: 'レディース' },
  mens: {id: 2, name: 'メンズ' },
  kids: {id: 3, name: 'キッズ' },
}

export default {
  data () {
    return {
      categories: _categories,
      genders: _genders,
    }
  }
}
